(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(function() { /* Failed to fetch product recommendations */ });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veganuary"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('ve_veg');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var email = document.getElementById('veemail').value.trim();
    var name = document.getElementById('ufname').value.trim();
    var msgDiv = document.getElementById('frm_msg');

    if (!email) {
      msgDiv.textContent = 'Please enter your email address.';
      msgDiv.style.color = '#c00';
      return;
    }

    var profileAttrs = { email: email };
    if (name) {
      var parts = name.split(' ');
      profileAttrs.first_name = parts[0];
      if (parts.length > 1) {
        profileAttrs.last_name = parts.slice(1).join(' ');
      }
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: "Valentine's Day Gift Guide Page",
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'WCmvSJ'
            }
          }
        }
      }
    };

    msgDiv.textContent = 'Submitting...';
    msgDiv.style.color = '#000';

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=RY9Urt', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2023-12-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      if (response.ok || response.status === 202) {
        msgDiv.textContent = 'Thank you for signing up!';
        msgDiv.style.color = '#205529';
        form.reset();
      } else {
        msgDiv.textContent = 'Something went wrong. Please try again.';
        msgDiv.style.color = '#c00';
      }
    })
    .catch(function() {
      msgDiv.textContent = 'Something went wrong. Please try again.';
      msgDiv.style.color = '#c00';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
